import { createRouter, createWebHashHistory } from 'vue-router';
const routes = [
  // 添加默认路由重定向
  {
    path: '/',
    redirect: '/HomeList' // 重定向到首页
  },
  /* -----------------------------登录------------------------------- */
  {
    path: '/MyLogin',
    name: 'MyLogin',
    meta: {
      title: '登录'
    },
    component: () => import('../views/MyLogin/MyLogin.vue')
  },
  /* -----------------------------对话------------------------------- */
  // 首页
  {
    path: '/HomeList',
    name: 'HomeList',
    meta: {
      title: '首页' // 配置title
    },
    component: () => import('../views/HomeList/HomeList.vue')
  },
  // 对话
  {
    path: '/HomePage',
    name: 'HomePage',
    meta: {
      title: '对话' // 配置title
    },
    component: () => import('../views/HomePage/HomePage.vue')
  },
  // AI市场
  {
    path: '/HealthServices',
    name: 'HealthServices',
    meta: {
      title: 'AI市场'
    },
    component: () => import('../views/HealthServices/HealthServices.vue')
  },
  // 我的
  {
    path: '/MineHealth',
    name: 'MineHealth',
    meta: {
      title: '我的'
    },
    component: () => import('../views/MineHealth/MineHealth.vue')
  },
  // AI视频
  {
    path: '/VoiceComponent',
    name: 'VoiceComponent',
    meta: {
      title: 'AI视频'
    },
    component: () => import('../views/VoiceComponent/VoiceComponent.vue')
  },
  // 我的创作
  {
    path: '/MyCreation',
    name: 'MyCreation',
    meta: {
      title: '我的创作'
    },
    component: () => import('../views/MyCreation/MyCreation.vue')
  },
  // 我的创作
  {
    path: '/MyCreationPicture',
    name: 'MyCreationPicture',
    meta: {
      title: '我的创作'
    },
    component: () => import('../views/MyCreationPicture/MyCreationPicture.vue')
  },
  // AI图片
  {
    path: '/AiPicture',
    name: 'AiPicture',
    meta: {
      title: 'AI图片'
    },
    component: () => import('../views/AiPicture/AiPicture.vue')
  },
  /* -----------------------------对话------------------------------- */
  // AI图片
  {
    path: '/TestPage',
    name: 'TestPage',
    meta: {
      title: 'TestPage'
    },
    component: () => import('../views/TestPage/TestPage.vue')
  },
  // 广场
  {
    path: '/Square',
    name: 'Square',
    meta: {
      title: '广场'
    },
    component: () => import('../views/Square/Square.vue')
  },
  // 选择音色
  {
    path: '/VoiceList',
    name: 'VoiceList',
    meta: {
      title: '选择音色'
    },
    component: () => import('../views/VoiceList/VoiceList.vue')
  },
  // 素材库
  {
    path: '/materialLibrary',
    name: 'materialLibrary',
    meta: {
      title: '素材库'
    },
    component: () => import('../views/materialLibrary/materialLibrary.vue')
  },
  // 素材列表
  {
    path: '/materialList',
    name: 'materialList',
    meta: {
      title: '素材列表'
    },
    component: () => import('../views/materialList/materialList.vue')
  },
  // 代理加盟
  {
    path: '/joinAgent',
    name: 'joinAgent',
    meta: {
      title: '代理加盟'
    },
    component: () => import('../views/joinAgent/joinAgent.vue')
  },
  // 佣金明细
  {
    path: '/agencyDetails',
    name: 'agencyDetails',
    meta: {
      title: '佣金明细'
    },
    component: () => import('../views/agencyDetails/agencyDetails.vue')
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

export default router;
